const SYMBOL_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/062qvh7d_logo-amine-transparente.png";
const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" style={{ backgroundColor: "#1A1A1A" }} className="py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Brand Symbol */}
          <div className="flex justify-center items-center py-8 md:py-12">
            <img
              src={SYMBOL_URL}
              alt="Amine Festas - Símbolo"
              className="w-40 md:w-56 h-auto object-contain"
              data-testid="manifesto-logo"
            />
          </div>

          {/* Right: Content */}
          <div className="space-y-6">
            <div>
              <span className="text-[#00929A] text-xs tracking-[0.25em] uppercase font-medium">Visão</span>
              <h2
                className="text-3xl sm:text-4xl font-light text-white tracking-tight mt-3"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Manifesto da Marca
              </h2>
              <div className="w-12 h-0.5 bg-[#00929A] mt-4" />
            </div>

            <p className="text-white/70 leading-relaxed text-base">
              Celebrar é mais do que um momento. É uma experiência, um conjunto de emoções que nos fazem sorrir, lembrar e, principalmente, sentir. Na Amine Festas, acreditamos que cada festa é única, porque cada pessoa é única.
            </p>
            <p className="text-white/70 leading-relaxed text-base">
              Somos apaixonados pela felicidade que um encontro pode gerar. O brilho no olhar de quem realiza o que sempre imaginou, o som das risadas, os abraços sinceros e os brindes cheios de significado.
            </p>
            <p className="text-white/70 leading-relaxed text-base">
              Por isso, não organizamos apenas eventos, nós criamos memórias. Somos a conexão entre o presente e as lembranças futuras, as histórias que serão contadas e recontadas.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 pt-4">
              <div className="p-5 bg-white/10 rounded-2xl border border-white/5">
                <h3 className="text-[#E4077B] text-sm font-medium mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>Nossa Visão</h3>
                <p className="text-sm text-white/60 leading-relaxed">
                  Ser referência em decoração afetiva e personalizada em Brasília, conhecida por encantar através dos detalhes.
                </p>
              </div>
              <div className="p-5 bg-white/10 rounded-2xl border border-white/5">
                <h3 className="text-[#00929A] text-sm font-medium mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>Nossa Missão</h3>
                <p className="text-sm text-white/60 leading-relaxed">
                  Transformar festas em momentos únicos, com decoração feita sob medida e atendimento humano.
                </p>
              </div>
            </div>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="manifesto-cta-btn"
              className="inline-flex items-center justify-center bg-[#00929A] hover:bg-[#007a80] text-white px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300 hover:shadow-lg hover:shadow-[#00929A]/20"
            >
              Orçamento Personalizado
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
